export const HEIGHT_SCALE = 0.70
export const MIN_HEIGHT = 250
export const PLACEHOLDER_PADDING_TOP = 56.25 * HEIGHT_SCALE
